import React from 'react';
import { Profile as SharedProfile } from '@monorepo/shared-components';
import popularSports from '../../data/popularSports';

const Profile = () => {
  return <SharedProfile popularActivities={popularSports} siteTheme="ubsports" />;
};

export default Profile;
